import React from 'react';
import SharedPricingCards from '../../components/Pricing/SharedPricingCards';

interface DesktopUpgradeProps {
    plans: any[];
    promoCode: string;
    setPromoCode: (v: string) => void;
    isApplying: boolean;
    promoError: string | null;
    promoSuccess: string | null;
    handleApplyPromo: () => void;
    handlePayment: (planId: string) => void;
    paymentLoading: boolean;
    navigate: (path: string) => void;
}

const DesktopUpgrade: React.FC<DesktopUpgradeProps> = ({
    plans, promoCode, setPromoCode, isApplying, promoError, promoSuccess,
    handleApplyPromo, handlePayment, paymentLoading, navigate
}) => {
    const getButtonLabel = (plan: any) => {
        if (plan.current) return 'Plan actuel';
        if (paymentLoading) return 'Redirection...';
        if (plan.planId === 'gratuit') return 'Plan actuel';
        return 'S\'abonner';
    };



    return (
        <div style={{ padding: '40px 20px', maxWidth: '1280px', margin: '0 auto' }}>
            {/* Simple Tagline Header */}
            <div style={{ 
                textAlign: 'center', marginBottom: '15px', 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
                padding: '12px 20px', borderRadius: '12px', color: 'white',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
            }}>
                <p style={{ fontSize: '1.1rem', fontStyle: 'italic', margin: 0, opacity: 0.95, fontWeight: '500' }}>
                    "Parce que la bonne action, c'est la bonne information. Obtenez un temps d'avance sur le marché."
                </p>
            </div>

            {/* Pricing Cards */}
            <div style={{ marginBottom: '40px' }}>
                <SharedPricingCards 
                    plans={plans} 
                    onPlanAction={(planId) => planId !== 'gratuit' ? handlePayment(planId) : null}
                    getButtonLabel={getButtonLabel}
                    isPaymentLoading={paymentLoading}
                    layout="desktop"
                />
            </div>

            {/* Bottom Section - Optimized Space */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '40px', marginTop: '20px' }}>
                {/* Promo Code - Better space usage */}
                <div style={{ padding: '32px', background: 'var(--bg-box)', borderRadius: '15px', border: '1px solid var(--border-color)', boxShadow: '0 4px 15px var(--shadow-color)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <h4 style={{ fontSize: '1.1rem', fontWeight: '700', color: 'var(--text-heading)', marginBottom: '15px' }}>🎁 Code Promo ?</h4>
                    <div style={{ display: 'flex', gap: '15px', width: '100%', maxWidth: '350px' }}>
                        <input 
                            type="text" 
                            value={promoCode} 
                            onChange={(e) => setPromoCode(e.target.value.toUpperCase())} 
                            placeholder="ENTREZ VOTRE CODE" 
                            style={{ 
                                flex: 1, padding: '12px', borderRadius: '8px', 
                                border: '1px solid var(--border-color)', background: 'var(--bg-input)', 
                                color: 'var(--text-main)', fontSize: '0.95rem', outline: 'none', 
                                textAlign: 'center', fontWeight: '600' 
                            }} 
                        />
                        <button 
                            onClick={handleApplyPromo} 
                            disabled={isApplying || !promoCode.trim()} 
                            style={{ 
                                padding: '12px 25px', 
                                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', 
                                color: 'white', border: 'none', borderRadius: '8px', 
                                fontSize: '1rem', fontWeight: '700', 
                                cursor: (isApplying || !promoCode.trim()) ? 'not-allowed' : 'pointer',
                                transition: 'all 0.3s',
                                boxShadow: '0 4px 10px rgba(16, 185, 129, 0.2)'
                            }}
                        >
                            {isApplying ? '...' : 'Valider'}
                        </button>
                    </div>
                    {promoError && <p style={{ color: '#ef4444', fontSize: '0.85rem', marginTop: '10px' }}>❌ {promoError}</p>}
                    {promoSuccess && <p style={{ color: '#10b981', fontSize: '0.85rem', marginTop: '10px', fontWeight: '600' }}>✅ {promoSuccess}</p>}
                </div>

                {/* B2B Section - Better space usage */}
                <div style={{ padding: '32px', background: 'var(--bg-hover)', borderRadius: '15px', textAlign: 'center', border: '1px solid var(--border-color)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <h3 style={{ fontSize: '1.4rem', fontWeight: '800', color: 'var(--text-heading)', marginBottom: '10px' }}>🏢 Licences B2B</h3>
                    <p style={{ fontSize: '1rem', color: 'var(--text-main)', marginBottom: '20px', maxWidth: '350px' }}>
                        SGI ou institution ? Obtenez des accès équipe et des tarifs personnalisés.
                    </p>
                    <button 
                        onClick={() => navigate('/settings/contacts?subject=b2b')} 
                        style={{ 
                            padding: '12px 40px', background: 'var(--text-heading)', 
                            color: 'var(--bg-box)', border: 'none', borderRadius: '8px', 
                            fontSize: '1rem', fontWeight: '700', cursor: 'pointer', transition: 'all 0.3s' 
                        }}
                    >
                        Contacter le support
                    </button>
                </div>
            </div>

            {/* Payment Info */}
            <div style={{ marginTop: '10px', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.75rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                <span>🔒</span>
                <p style={{ margin: 0 }}>Paiements sécurisés — PayDunia</p>
            </div>
        </div>
    );
};

export default DesktopUpgrade;
